export default "__VITE_ASSET__97b2de37__"